<template>
  <div class="bbox-container" v-if="shouldShowImage">
    <div
      v-for="(bbox, index) in bbox"
      :key="index"
      class="bbox"
      :style="getBboxStyle(bbox, index)"
      @mouseenter="highlightBbox(index)"
      @mouseleave="unhighlightBbox"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    bbox: null,
    shouldShowImage: {
      type: Boolean,
      required: true
    },
    w: null,
    h: null,
    highlightedBboxIndex: null,
    
  
  },
  methods: {
    highlightBbox(index) {
      console.log("highlightBbox====================", index);
      this.highlightedBboxIndex = index;
    },

    unhighlightBbox() {
      console.log("unhighlightBbox====================");
      this.highlightedBboxIndex = null;
    },

    getBboxStyle(bbox, index) {
      console.log("绘制框====================", bbox, index);
      const [x1, y1, x2, y2] = bbox.rel_coordinate.split(",").map(Number);
      console.log("绘制框====================", x1, y1, x2, y2);
      const width = (x2 - x1) * 928 / this.w;
      const height = (y2 - y1) * 522 / this.h;
      const left = 9 +  x1 * 928 / this.w;
      const top = 8 + y1 * 522 / this.h;
      console.log("绘制框====================", width, height, left, top);
      const style = {
        position: 'absolute',
        left: `${left}px`,
        top: `${top}px`,
        width: `${width}px`,
        height: `${height}px`,
        border: '0px solid blue', // 默认边框颜色
      };

      if (this.highlightedBboxIndex !== null && this.highlightedBboxIndex === index) {
        style.border = '0px solid blue'; // 高亮边框颜色
        style.backgroundColor = 'rgba(0, 0, 255, 0.3)';
      }

      return style;
    }
 }
}
</script>

<style scoped>
/* 添加你的样式 */
</style>